import {
  CpuChartData,
  GpuChartData,
  NumericSummary,
  StorageChartData,
  Summary,
} from './_types';

const toNumber = (big?: any): number => {
  if (typeof big?.toNumber === 'function') {
    return big.toNumber();
  }
  return big;
};

export const toNumericSummary = (summary: Summary): NumericSummary =>
  Object.fromEntries(
    Object.keys(summary)
      .filter((key) => key !== 'clusterId')
      .map((key) => [key, toNumber(summary[key as keyof typeof summary])])
  ) as NumericSummary;

const toPercentage =
  (provisioned: number) =>
  (x: number): number =>
    provisioned ? (x * 100) / provisioned : 0;

export const getCpuChartData = ({
  cpuProvisionedTotal: provisioned,
  cpuRequestedTotal: requested,
  cpuUsed: used,
  cpuAllocatableTotal: allocatable,
}: NumericSummary): CpuChartData => {
  const getPercentage = toPercentage(provisioned);
  const overhead = provisioned - allocatable;
  return {
    provisioned,
    requested,
    requestedPercentage: getPercentage(requested),
    used,
    usedPercentage: getPercentage(used),
    allocatable,
    allocatablePercentage: getPercentage(allocatable),
    overhead,
    overheadPercentage: getPercentage(overhead),
  };
};

export const getMemoryChartData = ({
  ramProvisionedTotal: provisioned,
  ramRequestedTotal: requested,
  ramUsed: used,
  ramAllocatableTotal: allocatable,
}: NumericSummary): CpuChartData => {
  const getPercentage = toPercentage(provisioned);
  const overhead = provisioned - allocatable;
  return {
    provisioned,
    requested,
    requestedPercentage: getPercentage(requested),
    used,
    usedPercentage: getPercentage(used),
    allocatable,
    allocatablePercentage: getPercentage(allocatable),
    overhead,
    overheadPercentage: getPercentage(overhead),
  };
};

export const getGpuChartData = ({
  gpuProvisionedTotal: provisioned,
  gpuRequestedTotal: requested,
  gpuAllocatableTotal: allocatable,
  gpuIdleTotal: idle,
  gpuUsedTotal: used,
  gpuNotUsedTotal: notUsed,
}: NumericSummary): GpuChartData => {
  const getPercentage = toPercentage(provisioned);
  return {
    provisioned,
    requested,
    requestedPercentage: getPercentage(requested),
    allocatable,
    allocatablePercentage: getPercentage(allocatable),
    idle,
    idlePercentage: getPercentage(idle),
    used,
    usedPercentage: getPercentage(used),
    notUsed,
    notUsedPercentage: getPercentage(notUsed),
  };
};

export const getStorageChartData = ({
  storageProvisioned: provisioned,
  storageRequested: requested,
}: NumericSummary): StorageChartData => {
  const getPercentage = toPercentage(provisioned);
  return {
    provisioned,
    requested,
    requestedPercentage: getPercentage(requested),
  };
};
